<template>
  <div class="index" style="padding: 10px">
    <div style="display: flex; line-height: 41px; font-size: 14px">
      <Tabs style="margin-bottom: 18px" value="1" @on-click="statistics">
        <TabPane label="团队统计" name="1"> </TabPane>
        <TabPane label="产品统计" name="2"></TabPane>
        <TabPane label="银行统计" name="3"></TabPane>
      </Tabs>

      <Tabs
        style="margin-bottom: 18px; margin-left: 15px"
        value="1"
        @on-click="switchover"
      >
        <TabPane label="今日" name="1"> </TabPane>
        <TabPane label="昨日" name="2"></TabPane>
        <TabPane label="本月" name="3"></TabPane>
        <TabPane label="上月" name="4"></TabPane>
        <TabPane label="全部" name="5"></TabPane>
      </Tabs>
      <div style="margin-left: 40px; font-size: 18px; font-weight: 900">
        合计:{{ total }}
      </div>
    </div>
    <div class="content" v-if="type == 1">
      <div
        style="
          border: 1px solid #eee;
          border-radius: 5px;
          width: 240px;
          font-size: 16px;
          margin: 0 20px 20px 0;
          height: 69px;
        "
        v-for="(item, index) in TeamStatisticsData"
        :key="index"
        @click="particulars(item.groupNo)"
      >
        <div style="padding: 5px; background: #eee; font-weight: 900">
          {{ item.groupName }}
        </div>
        <div style="padding: 5px">
          {{ item.count }}
        </div>
      </div>
    </div>
    <div class="content" v-if="type == 2">
      <div class="list" v-for="(item, index) in data">
        <img :src="item.productLogo" alt="" srcset="" />
        <div>
          <div class="title">{{ item.productName }}</div>
          <div style="font-size: 14px">{{ item.count }}</div>
        </div>
      </div>
      <div style="height: 20px; width: 100%"></div>
    </div>
    <div class="content" v-if="type == 3">
      <div class="list" v-for="(item, index) in data">
        <img :src="item.productLogo" alt="" srcset="" />
        <div>
          <div class="title">{{ item.productName }}</div>
          <div style="font-size: 14px">{{ item.count }}</div>
        </div>
      </div>
      <div style="height: 20px; width: 100%"></div>
    </div>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      data: {},
      total: "",
      type: 1,
      TeamStatisticsData: [],
      groupNo: null,
      time: 1,
    };
  },
  mounted: function () {
    this.TeamStatistics(
      Date.parse(new Date().toLocaleDateString()),
      Date.parse(new Date())
    );
    // this.getData(
    //   Date.parse(new Date().toLocaleDateString()),
    //   Date.parse(new Date())
    // );
    this.style2();
  },
  methods: {
    particulars(groupNo) {
      this.groupNo = groupNo;
      this.type = 2;
      this.switchover(this.time);
    },
    statistics(name) {
      this.type = name;
      this.style1();
      this.style();
      this.switchover(this.time, 1);
    },
    getStartTime() {
      let date = new Date();
      date.setDate(1); // 将当前时间的日期设置成第一天
      let year = date.getFullYear(); // 得到当前年份
      let month = date.getMonth() + 1; // 得到当前月份（0-11月份，+1是当前月份）
      month = month > 10 ? month : "0" + month; // 补零
      let day = date.getDate(); // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
      // console.log(month) 03
      return new Date(year + "/" + month + "/" + day); // 这里传入的是字符串
    },
    switchover(name, type) {
      if (type == 1) {
        this.groupNo = null;
      }
      this.time = name;
      this.style1();
      if (this.time == 1) {
        if (this.type == 1) {
          this.TeamStatistics(
            Date.parse(new Date().toLocaleDateString()),
            Date.parse(new Date())
          );
        } else {
          this.getData(
            Date.parse(new Date().toLocaleDateString()),
            Date.parse(new Date())
          );
        }
      }
      if (this.time == 2) {
        if (this.type == 1) {
          this.TeamStatistics(
            Date.parse(new Date().toLocaleDateString()) - 86400000,
            Date.parse(new Date().toLocaleDateString())
          );
        } else {
          this.getData(
            Date.parse(new Date().toLocaleDateString()) - 86400000,
            Date.parse(new Date().toLocaleDateString())
          );
        }
      }
      if (this.time == 3) {
        if (this.type == 1) {
          this.TeamStatistics(
            Date.parse(this.getStartTime().toLocaleDateString()),
            Date.parse(new Date())
          );
        } else {
          this.getData(
            Date.parse(this.getStartTime().toLocaleDateString()),
            Date.parse(new Date())
          );
        }
      }
      if (this.time == 4) {
        let curDate = new Date();
        let y = curDate.getFullYear();
        let m = curDate.getMonth();
        if (m > 12) {
          //月份大于12划为下一年
          m = 1;
          y++;
        }
        if (m === 0) {
          //月份等于0时
          m = 12;
          y--;
        }
        let lastStartDay = y + "/" + (m < 10 ? "0" + m : m) + "/" + "01";

        if (this.type == 1) {
          this.TeamStatistics(
            Date.parse(new Date(lastStartDay).toLocaleDateString()),
            Date.parse(this.getStartTime().toLocaleDateString())
          );
        } else {
          this.getData(
            Date.parse(new Date(lastStartDay).toLocaleDateString()),
            Date.parse(this.getStartTime().toLocaleDateString())
          );
        }
      }
      if (this.time == 5) {
        if (this.type == 1) {
          this.TeamStatistics(-10, -110);
        } else {
          this.getData(-10, -110);
        }
      }
    },
    TeamStatistics(startMillisecond, endMillisecond) {
      api
        .TeamStatistics({
          startMillisecond,
          endMillisecond,
        })
        .then((res) => {
          this.TeamStatisticsData = res.body.data;
          this.total = 0;
          this.TeamStatisticsData.forEach((element) => {
            this.total = this.total + element.count;
          });
          this.style();
        });
    },

    getData(startMillisecond, endMillisecond) {
      let aggregation;
      if (this.type == 2) {
        aggregation = 0;
      }
      if (this.type == 3) {
        aggregation = 1;
      }
      api
        .QueryStatistics({
          startMillisecond,
          endMillisecond,
          groupNo: this.groupNo,
          aggregation,
        })
        .then((res) => {
          this.total = 0;
          this.data = res.body.data;
          this.data.forEach((element) => {
            this.total = element.count + this.total;
          });
          this.style();
        });
    },
    style() {
      setTimeout(() => {
        document.getElementsByClassName("ivu-tabs-nav")[0].style.borderRadius =
          "50px";
        document.getElementsByClassName("ivu-tabs-bar")[0].style.border =
          "none";
        document.getElementsByClassName(
          "ivu-tabs-nav-scroll"
        )[0].style.overflow = "initial";
        document.getElementsByClassName("ivu-tabs-nav-wrap")[0].style.overflow =
          "initial";
        document.getElementsByClassName("ivu-tabs-ink-bar")[0].style.height =
          "34px";
        document.getElementsByClassName(
          "ivu-tabs-ink-bar"
        )[0].style.borderRadius = "50px";
        document.getElementsByClassName("ivu-tabs-tab-active")[0].style.color =
          "#fff";
        document.getElementsByClassName("ivu-tabs-tab-active")[0].style.zIndex =
          "10000";
        document.getElementsByClassName("ivu-tabs-nav")[0].style.border =
          "1px solid #ccc";
        document.getElementsByClassName("ivu-tabs-ink-bar")[1].style.height =
          "34px";
        document.getElementsByClassName(
          "ivu-tabs-ink-bar"
        )[1].style.borderRadius = "50px";
        document.getElementsByClassName("ivu-tabs-tab-active")[1].style.color =
          "#fff";
        document.getElementsByClassName("ivu-tabs-tab-active")[1].style.zIndex =
          "10000";
        document.getElementsByClassName("ivu-tabs-nav")[1].style.border =
          "1px solid #ccc";
        document.getElementsByClassName("ivu-tabs-nav")[1].style.borderRadius =
          "50px";
        document.getElementsByClassName("ivu-tabs-bar")[1].style.border =
          "none";
        document.getElementsByClassName(
          "ivu-tabs-nav-scroll"
        )[1].style.overflow = "initial";
        document.getElementsByClassName("ivu-tabs-nav-wrap")[1].style.overflow =
          "initial";
      }, 100);
    },
    style1() {
      document.getElementsByClassName("ivu-tabs-tab")[0].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[1].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[2].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[3].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[4].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[5].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[6].style.color =
        "#515a6e";
      document.getElementsByClassName("ivu-tabs-tab")[7].style.color =
        "#515a6e";
    },
    style2() {
      document.getElementsByClassName("ivu-tabs-nav")[0].style.width = "305px";
      document.getElementsByClassName("ivu-tabs-nav")[0].style.paddingLeft =
        "2px";
      document.getElementsByClassName("ivu-tabs-ink-bar")[0].style.background =
        "#191996";
      document.getElementsByClassName("ivu-tabs-ink-bar")[0].style.left = "2px";
      document.getElementsByClassName("ivu-tabs-nav")[1].style.width = "370px";
      document.getElementsByClassName("ivu-tabs-nav")[1].style.paddingLeft =
        "2px";
      document.getElementsByClassName("ivu-tabs-ink-bar")[1].style.background =
        "#191996";

      document.getElementsByClassName("ivu-tabs-ink-bar")[1].style.left = "2px";
    },
  },
};
</script>

<style scoped>
.index {
  color: #000;
  height: 800px;
  border-radius: 10px;
  background: #fff;
}
.content {
  height: 150px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.list {
  border: 1px solid #e7e6e6;
  height: 68%;
  width: 290px;
  border-radius: 5px;
  margin-right: 21px;

  display: flex;
  align-items: center;
  margin-bottom: 21px;
}
.list img {
  width: 52px;
  margin-left: 20px;
}
.list div {
  margin-left: 15px;
  line-height: 35px;
}
.title {
  font-size: 17px;
  font-weight: 600;
}
</style>
